import { IApplicationState, TListId } from '../../../types/types';
import { TStatus } from '../../../types/model';
import { ICard } from '../card/types';
import { getList } from '../list/selectors/getList';
import { getCard } from './getCard';

export const getListCardsByStatus = (
    state: IApplicationState,
    listId: TListId,
    status: TStatus = TStatus.STATUS_ACTIVE,
): ICard[] => {
    const list = getList(state, listId);
    if (
        !list ||
        !list.cardIds ||
        !list.cardIds.length
    ) return [];

    const cards = list.cardIds.reduce((arr, cardId) => {
        const card = getCard(state, cardId);
        if (!card) return arr;

        if (card.status === status) {
            arr.push(card);
        }
        return arr;
    }, []);
    return cards;
};
